export const STUDENT_REQUEST_PENDING = "STUDENT_REQUEST_PENDING";
export const STUDENT_REQUEST_FAILURE = "STUDENT_REQUEST_FAILURE";
export const STUDENT_REQUEST_SUCCESS = "STUDENT_REQUEST_SUCCESS";
